import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const UserManagementBuyerStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1350px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .name {
        flex: 0 0 14%;
      }

      .email {
        flex: 0 0 15%;
      }

      .employee-id {
        flex: 0 0 8%;
        min-width: 160px;
        justify-content: center;
        text-align: center;
      }

      .status {
        flex: 0 0 12%;
        min-width: 95px;
      }

      .role {
        /* flex: 0 0 21%; */
        min-width: 100px;
        justify-content: center;
        text-align: center;
        display: flex;
      }

      .actions {
        flex: 0 0 10%;
        min-width: 130px;
        padding: 14px 0 0 1%;
      }

      &.header {
        .actions {
          padding: 9px 0 10px 1%;
        }

        .role {
          justify-content: center;
          text-align: center;
        }
      }
    }
  }

  .role-flex {
    display: flex;
  }

  .background-white {
    background-color: white;
    opacity: 1 !important;
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.12) !important;
    border: 0 !important;
    color: ${VARIABLES.COLORS.GRAY_3};
    white-space: pre-line;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};

    &.place-bottom {
      border-bottom-color: white;

      &:after,
      &:before {
        display: none;
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 1280.98px) {
    .content-body:has(#filter_search_input:focus) {
      .tbody {
        .table-column {
          div {
            color: #06304f;
          }
        }
      }
    }
  }

  @media all and (max-width: 1600.98px) {
    .table {
      .table-row {
        .actions {
          min-width: 120px;
        }
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    .table {
      .table-row {
        .actions {
          min-width: 110px;
        }
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    .table {
      .table-row {
        .actions {
          min-width: 95px;
        }
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    .table {
      .table-row {
        .actions {
          min-width: 80px;
        }
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    .table {
      .table-row {
        .actions {
          min-width: 50px;
        }
      }
    }
  }
`

export const UserManagementAdminStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1350px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .id {
        flex: 0 0 12%;
        min-width: 160px;
      }

      .name {
        flex: 0 0 17%;
      }

      .email {
        flex: 0 0 26%;
      }

      .phone {
        flex: 0 0 13%;
      }

      .role {
        flex: 0 0 7%;
        min-width: 100px;
      }

      .created-date {
        flex: 0 0 15%;
      }

      .actions {
        flex: 0 0 10%;
        min-width: 130px;
        padding: 14px 0 0 2.5%;
      }

      &.header {
        .actions {
          padding: 9px 0 10px 2.8%;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const UserManagementSupplierStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1350px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .id {
        flex: 0 0 12%;
        min-width: 160px;
      }

      .name {
        flex: 0 0 17%;
      }

      .email {
        flex: 0 0 17%;
      }

      .status {
        flex: 0 0 17%;
        min-width: 110px;
      }

      .role {
        flex: 0 0 12%;
        min-width: 100px;
      }

      .created-date {
        flex: 0 0 15%;
      }

      .actions {
        flex: 0 0 10%;
        min-width: 130px;
        padding: 14px 0 0 2.5%;
      }

      &.header {
        .actions {
          padding: 9px 0 10px 2.8%;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
